<template>
  <b-button-group size="sm">
    <b-button variant="primary" class="actionButton" :to="`/ofertas/editar/${oferta.id}`">
      <v-icon variant="primary" name="edit" width="16" /><span>Editar</span>
    </b-button>

    <!-- Oferta -->
    <b-dropdown size="sm" right text="" variant="dark" class="actionButton">
      <template slot="button-content">
        <v-icon variant="primary" name="menu" width="16" />
      </template>

      <!-- Flujo -->
      <!-- Visar -->
      <b-dropdown-item :disabled="!puedeVisar" size="sm" @click="visarVersion(oferta.id, oferta.descripcion)">
        <v-icon variant="primary" name="check" width="16" /> Visar
      </b-dropdown-item>
      <!-- Entregar al cliente -->
      <b-dropdown-item :disabled="!puedeEntregar" size="sm" @click="entregarVersion(oferta.id, oferta.descripcion)">
        <v-icon variant="primary" name="send" width="16" /> Entregar al cliente
      </b-dropdown-item>
      <!-- Ganar -->
      <b-dropdown-item :disabled="!puedeGanar" size="sm" :to="`/ofertas/ganar/${oferta.id}`">
        <v-icon variant="primary" name="thumbs-up" width="16" /> Ganar
      </b-dropdown-item>
      <!-- Perder -->
      <b-dropdown-item :disabled="!puedePerder" size="sm" :to="`/ofertas/perder/${oferta.id}`">
        <v-icon variant="primary" name="thumbs-down" width="16" /> Perder
      </b-dropdown-item>

      <b-dropdown-divider />

      <!-- Nueva versión -->
      <b-dropdown-item :disabled="!puedeVersionar" size="sm" @click="crearVersion(oferta.id, oferta.descripcion)">
        <v-icon variant="primary" name="copy" width="16" /> Nueva Versión
      </b-dropdown-item>

      <!-- Histórico de versiones -->
      <b-dropdown-item size="sm" :to="`/ofertas/versiones/${oferta.ofertaBaseId}`">
        <v-icon variant="primary" name="list" width="16" /> Histórico de Versiones
      </b-dropdown-item>

      <b-dropdown-divider />

      <!-- Informes -->
      <b-dropdown-item
        :disabled="!puedeImprimir"
        size="sm"
        target="_blank"
        :href="`${url}/ofertaInforme/informeConsultor&ofertaId=${oferta.id}`"
      >
        <v-icon variant="primary" name="printer" width="16" />
        Informe Consultor
      </b-dropdown-item>

      <b-dropdown-item
        :disabled="!puedeImprimir"
        size="sm"
        target="_blank"
        :href="`${url}/ofertaInforme/informeComercial&ofertaId=${oferta.id}`"
      >
        <v-icon variant="primary" name="printer" width="16" /> Informe Comercial
      </b-dropdown-item>

      <b-dropdown-item
        :disabled="!puedeImprimir"
        size="sm"
        target="_blank"
        :href="`${url}/ofertaInforme/informeComercial&ofertaId=${oferta.id}&tipoInforme=extendido`"
      >
        <v-icon variant="primary" name="printer" width="16" /> Informe Com. Extendido
      </b-dropdown-item>

      <b-dropdown-item
        :disabled="!esGanada"
        size="sm"
        target="_blank"
        :href="`${url}/ofertaInforme/informeAdministracion&ofertaId=${oferta.id}`"
      >
        <v-icon variant="primary" name="printer" width="16" />
        Informe Administración
      </b-dropdown-item>

      <b-dropdown-divider v-show="oferta.pipedrive" />

      <b-dropdown-item size="sm" target="_blank" v-show="oferta.pipedrive" :href="oferta.pipedrive">
        <v-icon variant="primary" name="database" width="16" /> Abrir en Pipedrive
      </b-dropdown-item>
    </b-dropdown>
  </b-button-group>
</template>
<script>
import { mapState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import * as ofertasApi from "@/services/ofertas";

export default {
  props: {
    oferta: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
    puedeImprimir() {
      return true;
    },
    puedeVersionar() {
      return true;
    },
    puedeVisar() {
      return (
        !this.oferta.visada && !this.oferta.perdida && (!this.oferta.caducada || (this.oferta.caducada && this.esAdmin))
      );
    },
    puedeEntregar() {
      return (
        !this.oferta.perdida &&
        !this.oferta.entregada &&
        this.oferta.visada &&
        (!this.oferta.caducada || (this.oferta.caducada && this.esAdmin))
      );
    },
    puedeGanar() {
      return (
        !this.oferta.perdida &&
        this.oferta.entregada &&
        !this.oferta.ganada &&
        (!this.oferta.caducada || (this.oferta.caducada && this.esAdmin))
      );
    },
    esGanada() {
      return this.oferta.ganada;
    },
    puedePerder() {
      return (
        !this.oferta.ganada &&
        !this.oferta.perdida &&
        this.oferta.entregada &&
        (!this.oferta.caducada || (this.oferta.caducada && this.esAdmin))
      );
    },
    permiteAgregarOrdenDeCompra() {
      return this.esAdmin;
    },
  },
  methods: {
    mostrarMensaje(msg) {
      this.$messages.success(msg);
    },
    async crearVersion(id) {
      var version = await ofertasApi.crearVersion(id);
      this.$router.push({
        path: "/ofertas/editar/" + version.id,
      });
      this.$messages.success(`Se ha creado la versión v${version.numeroVersion}`);
    },
    async entregarVersion(id, descripcion) {
      await ofertasApi.entregarVersion(id);
      this.mostrarMensaje(`Oferta '${descripcion}' entregada`);
      this.$emit("ofertaCambiada", id);
    },
    async visarVersion(id, descripcion) {
      await ofertasApi.visarVersion(id);
      this.mostrarMensaje(`Oferta '${descripcion}' visada`);
      this.$emit("ofertaCambiada", id);
    },
    async perderVersion(id, descripcion) {
      await ofertasApi.perderVersion(id);
      this.mostrarMensaje(`Oferta '${descripcion}' perdida`);
      this.$emit("ofertaCambiada", id);
    },
    async enviarVersionPapelera(id, descripcion) {
      await ofertasApi.enviarVersionPapelera(id);
      this.mostrarMensaje(`Oferta '${descripcion}' enviada a la Papelera`);
      this.$emit("ofertaCambiada", id);
    },
  },
  data() {
    return {
      url: process.env.VUE_APP_ENDPOINT,
      clienteIncompletoId: "",
    };
  },
};
</script>
